import { validDownSellLicense } from '@/utils/validate-downsell';

export default {
  data() {
    return {
      mx_downSellLicenseErrorMessage: '',
    };
  },
  methods: {
    mx_validDownSellLicense(license) {
      if (this.$context.is.editPage) {
        const { errorMessage } = validDownSellLicense({ quantity: license });
        this.mx_downSellLicenseErrorMessage = errorMessage;

        if (this.mx_downSellLicenseErrorMessage && this.trackingPlanName) {
          this.$tracking.buyInteraction(
            'banner - product level',
            `${this.trackingPlanName} - ${this.mx_downSellLicenseErrorMessage} - impression`,
          );
        }
      }
    },
  },
};
